function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState, useRef, useReducer } from 'react';
import { Redirect, Route, useHistory, useLocation } from 'react-router-dom';
import { FunctionalLoader, useDidUpdate, Page, PageContentHeader, Typography, useStateInRef } from 'seagull';
import ErrorBoundaryPage from "../../components/ErrorBoundaryPage/ErrorBoundaryPage";
import FeatureFlagsRelationshipContext from "../../components/FeatureFlagsRelationshipContext";
import { routes } from "../../constants";
import { useOverlayContext, useStore } from "../../contexts";
import { useRelationship } from "../../hooks/reactQuery/queries/useRelationship.tsx";
import { useOnMount } from "../../hooks/useOnMount";
import { useSetDocumentTitle } from "../../hooks/useSetDocumentTitle";
import { relationshipModel, relationshipSummaryModel } from "../../models";
import { BIRelationshipScopeProvider } from "../../providers/BIRelationshipScopeProvider";
import { selectors } from "../../store/state-selectors";
import { FilterType } from "../AgreementsDashboard/agreementsDashboardFilters";
import ActivityLog from "./ActivityLog/ActivityLog";
import styles from "./AgreementMinisite.module.scss";
import AgreementMinisiteTopBar from "./AgreementMinisiteTopBar/AgreementMinisiteTopBar";
import AgreementView from "./AgreementView/AgreementView";
import ApproveAllBar from "./ApproveAll/ApproveAllBar";
import BillingHub from "./BillingHub/BillingHub";
import InvoicesView from "./InvoicesView/InvoicesView";
import PaymentMethods from "./PaymentMethods/PaymentMethods";
import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const minisiteTabs = {
  billingHub: {
    url: 'billing-hub',
    label: 'Billing Hub',
    supportsSample: false
  },
  agreement: {
    url: 'agreement',
    label: 'Agreement',
    supportsSample: true
  },
  paymentMethods: {
    url: 'payment-methods',
    label: 'Payment Methods',
    supportsSample: false
  },
  invoices: {
    url: 'invoices',
    label: 'Invoices',
    supportsSample: false
  },
  activity: {
    url: 'activity',
    label: 'Activity Log',
    supportsSample: false
  }
};
function ActualMinisite(props) {
  const {
    relationship,
    refresh,
    match
  } = props;
  const getProps = useStateInRef(props);
  const location = useLocation();
  const numAmendments = relationshipModel.numAmendments(relationship);
  const numInvoicesRequiringApproval = relationshipModel.numInvoicesRequiringApproval(relationship);
  const amountOfPendingCharges = relationshipModel.numPendingCharges(relationship);
  const userIsVendor = useStore(selectors.user.isVendorInRelationship(relationship));
  const history = useHistory();
  const locationStack = useStore(selectors.locationStack);
  const overlayContext = useOverlayContext();
  const scrollContainerRef = useRef(null);
  const [dismissedApproveAll, setDismissedApproveAll] = useState(false);
  const [tabRefreshKey, remountCurrentTab] = useReducer(state => state + 1, 0);
  const [billingHubKey, agreementViewKey, paymentMethodsKey, invoicesViewKey, activityLogKey] = new Array(5).fill(tabRefreshKey).map((val, i) => val + i);
  const scrollElRef = useRef(null);
  const relationshipScope = {
    id: relationship.id,
    isApproved: relationshipModel.isApproved(relationship)
  };
  const shouldShowApproveAllModal = !dismissedApproveAll && !userIsVendor && relationshipModel.isApproved(relationship) && numAmendments + numInvoicesRequiringApproval + amountOfPendingCharges > 1;
  const currentTabUrl = match.path === location.pathname ? null : (location.pathname.match(new RegExp(match.url + '/([^/]*)')) || {})[1];
  useDidUpdate(() => {
    const el = scrollElRef.current;
    if (el) {
      el.scrollTop = 0;
    }
  }, [location.pathname]);
  useDidUpdate(() => {
    getProps().refresh();
  }, [match.params.relationshipId]);
  const currentTab = Object.keys(minisiteTabs).find(tabName => minisiteTabs[tabName].url === currentTabUrl);
  useOnMount(() => {
    var _location$state;
    if (!currentTab) {
      const path = relationshipModel.isApproved(relationship) ? minisiteTabs.billingHub.url : minisiteTabs.agreement.url;
      history.replace("".concat(match.url, "/").concat(path));
    }
    if ((_location$state = location.state) !== null && _location$state !== void 0 && _location$state.scrollToBottom && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
    }
  });
  const agreementUrl = "".concat(match.url, "/").concat(minisiteTabs.agreement.url);
  const paymentMethodsUrl = "".concat(match.url, "/").concat(minisiteTabs.paymentMethods.url);
  const displayedTitle = relationshipModel.displayedTitle(relationship, userIsVendor);
  return /*#__PURE__*/_jsx(BIRelationshipScopeProvider, {
    relationshipScope: relationshipScope,
    children: /*#__PURE__*/_jsx(Page, {
      "data-testid": "minisite-page",
      ref: scrollElRef,
      header: /*#__PURE__*/_jsxs(_Fragment, {
        children: [relationshipModel.opposingPartyName(relationship, userIsVendor), displayedTitle && /*#__PURE__*/_jsxs(Typography, {
          as: "span",
          variant: "h4",
          ellipsis: true,
          children: ["\xA0\u2014 ", displayedTitle]
        })]
      }),
      onClickBack: () => {
        if (locationStack.length > 1) {
          const lastLocation = locationStack[locationStack.length - 2];
          if (lastLocation.pathname === routes.agreementsDashboard) {
            history.goBack();
            return;
          }
        }
        if (relationshipModel.isApproved(relationship) || relationshipModel.isTerminated(relationship)) {
          const agreementStatusKey = FilterType.AgreementStatus;
          const searchParams = relationshipModel.isApproved(relationship) ? {} : {
            [agreementStatusKey]: relationshipSummaryModel.AgreementStatus.Terminated
          };
          const search = "?".concat(new URLSearchParams(searchParams));
          history.push({
            pathname: routes.agreementsDashboard,
            search
          });
        } else {
          history.push(routes.proposalsDashboard);
        }
      },
      children: /*#__PURE__*/_jsx("div", {
        className: styles.main,
        "data-testid": "agreement-minisite",
        children: /*#__PURE__*/_jsxs(ErrorBoundaryPage, {
          bounded: true,
          children: [/*#__PURE__*/_jsxs(PageContentHeader, {
            children: [shouldShowApproveAllModal && /*#__PURE__*/_jsx(ApproveAllBar, {
              agreement: relationship,
              amendments: numAmendments,
              invoices: numInvoicesRequiringApproval,
              charges: amountOfPendingCharges,
              onClose: _ref => {
                let {
                  status
                } = _ref;
                if (status === 'success') {
                  refresh();
                  remountCurrentTab();
                  overlayContext.showSuccessToast('Approved successfully', 'approve-all-success-toast');
                  if (!shouldShowApproveAllModal) {
                    setDismissedApproveAll(true);
                  }
                } else if (status === 'error') {
                  overlayContext.showErrorToast('An error occurred. Try again or contact the vendor.');
                } else if (status === 'dismissed') {
                  setDismissedApproveAll(true);
                }
              }
            }), /*#__PURE__*/_jsx(AgreementMinisiteTopBar, {
              relationship: relationship,
              tabs: minisiteTabs
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: styles.errorBoundary,
            children: /*#__PURE__*/_jsxs(ErrorBoundaryPage, {
              bounded: true,
              children: [(!relationship.isSample || minisiteTabs.billingHub.supportsSample) && /*#__PURE__*/_jsx(Route, {
                path: "".concat(match.url, "/").concat(minisiteTabs.billingHub.url),
                exact: true,
                render: props => /*#__PURE__*/_jsx(BillingHub, _objectSpread({
                  isVendor: userIsVendor,
                  agreement: relationship,
                  refreshAgreement: refresh
                }, props))
              }, billingHubKey), (!relationship.isSample || minisiteTabs.agreement.supportsSample) && /*#__PURE__*/_jsx(Route, {
                path: agreementUrl,
                children: /*#__PURE__*/_jsx("div", {
                  ref: scrollContainerRef,
                  className: styles.content,
                  "data-testid": 'agreement-minisite-agreement-tab',
                  children: /*#__PURE__*/_jsx(AgreementView, {
                    relationship: relationship,
                    isVendor: userIsVendor,
                    refresh: refresh
                  })
                })
              }, agreementViewKey), (!relationship.isSample || minisiteTabs.invoices.supportsSample) && /*#__PURE__*/_jsx(Route, {
                path: "".concat(match.url, "/").concat(minisiteTabs.invoices.url),
                render: props => /*#__PURE__*/_jsx(InvoicesView, _objectSpread({
                  //This is a dirty trick to refresh the data after approving invoices
                  agreement: relationship,
                  viewMode: userIsVendor ? 'vendor' : 'customer',
                  refreshAgreement: refresh
                }, props), "invoices-view-".concat(dismissedApproveAll))
              }, invoicesViewKey), (!relationship.isSample || minisiteTabs.billingHub.supportsSample) && /*#__PURE__*/_jsx(Route, {
                path: "".concat(match.url, "/").concat(minisiteTabs.activity.url),
                render: props => /*#__PURE__*/_jsx(ActivityLog, _objectSpread({
                  agreement: relationship
                }, props))
              }, activityLogKey), (!relationship.isSample || minisiteTabs.paymentMethods.supportsSample) && /*#__PURE__*/_jsx(Route, {
                path: paymentMethodsUrl,
                render: () => /*#__PURE__*/_jsx(PaymentMethods, {
                  isVendor: userIsVendor,
                  agreement: relationship,
                  onRefreshAgreement: refresh
                })
              }, paymentMethodsKey)]
            })
          })]
        })
      })
    })
  });
}
export default function AgreementMinisite(props) {
  const {
    relationship,
    refresh,
    isLoading,
    error
  } = useRelationship(props.match.params.relationshipId, {
    refreshOnMount: true
  });
  useSetDocumentTitle('Agreement');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FunctionalLoader, {
      show: isLoading
    }), relationship && (relationshipModel.isApproved(relationship) || relationshipModel.isTerminated(relationship) ? /*#__PURE__*/_jsx(FeatureFlagsRelationshipContext, {
      vendorId: relationship.vendor.id,
      children: /*#__PURE__*/_jsx(ActualMinisite, _objectSpread(_objectSpread({}, props), {}, {
        relationship: relationship,
        refresh: refresh
      }))
    }) : /*#__PURE__*/_jsx(Redirect, {
      to: routes.home
    })), !!error && /*#__PURE__*/_jsx(Redirect, {
      to: routes.home
    })]
  });
}